import React, { useContext } from "react";
import './Popular.css';
import { ShopContext } from "../../context/ShopContext";
import Item from '../items/Item';
import CustomizeBlouseItem from '../items/CustomizeBlouseItem';

// "Design Yours" isn't a Firestore product, so it can't carry a `popular`
// value in the catalog files - its display position is set here instead.
const DESIGN_YOURS_POSITION = 2;

const Popular = () => {
    const { all_product } = useContext(ShopContext);
    // `popular` is the display position (1 = first) - Firestore doc order
    // doesn't reflect it, so sort explicitly rather than relying on fetch order.
    const popularEntries = [
        ...all_product
            .filter((item) => item.popular)
            .map((item) => ({ position: item.popular, element: <Item key={item.id} product={item} /> })),
        { position: DESIGN_YOURS_POSITION, element: <CustomizeBlouseItem key="design-yours" /> },
    ].sort((a, b) => a.position - b.position);

    return (
        <div className="popular">
            <span className="title-font">Popular Picks</span>
            <hr />
            <div className="popular-items">
                {popularEntries.map((entry) => entry.element)}
            </div>
        </div>
    )
}

export default Popular;
